<template>
  <v-tabs v-model="tab" class="elevation-3">
    <v-tab href="#tab-devices">{{ $t('PROFILE.DEVICES') }}</v-tab>
    <v-tab v-if="$can('sensitive-data')" href="#tab-relations">{{ $t('PROFILE.RELATIONS') }}</v-tab>
    <v-tab v-if="$can('sensitive-data')" href="#tab-helper">{{ $t('RELATIONS.HELPER') }}</v-tab>
    <v-tab href="#tab-employment">{{ $t('PROFILE.EMPLOYMENT') }}</v-tab>
    <v-tab href="#tab-documents">{{ $t('PROFILE.DOCUMENTS') }}</v-tab>
    <v-tab href="#tab-shared-documents">{{
      $t('PROFILE.SHARED_DOCUMENTS')
    }}</v-tab>
    <v-tab href="#tab-tags">{{ $t('PERSONAL_INTERESTS.ITEMS') }}</v-tab>
    <v-tab href="#tab-communication-options">{{
      $t('COMMUNICATION_OPTIONS.ITEMS')
    }}</v-tab>
    <v-tab href="#tab-notifications">{{ $t('NOTIFICATIONS.ITEMS') }}</v-tab>
    <v-tab href="#tab-inhabitant-history">{{
      $t('INHABITANTS.HISTORY')
    }}</v-tab>

    <v-tab-item value="tab-devices">
      <v-card flat tile>
        <devices :person-id="person.id" />
      </v-card>
    </v-tab-item>

    <v-tab-item v-if="$can('sensitive-data')" value="tab-relations">
      <v-card flat tile>
        <relations :person="person" />
      </v-card>
    </v-tab-item>

    <v-tab-item v-if="$can('sensitive-data')" value="tab-helper">
      <v-card flat tile>
        <helper :person-id="person.id" />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-employment">
      <v-card flat tile>
        <employment :items="person.work_profiles" />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-documents">
      <v-card flat tile>
        <documents :person="person" />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-shared-documents">
      <v-card flat tile>
        <shared-documents :person-id="person.id" />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-tags">
      <v-card flat tile>
        <tags
          v-if="person.user"
          :user-id="person.user.id"
          :person-id="person.id"
        />
        <div v-else></div>
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-communication-options">
      <v-card flat tile>
        <communication-options v-if="person" :person-id="person.id" />
        <div v-else></div>
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-notifications">
      <v-card flat tile>
        <notifications v-if="person.user" :user-id="person.user.id" />
        <notifications v-else :user-id="0" />
      </v-card>
    </v-tab-item>

    <v-tab-item value="tab-inhabitant-history">
      <v-card flat tile>
        <inhabitant-history :person="person" />
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import Employment from './Employment';
import Relations from './Relations';
import Helper from '@/modules/persons/components/Tabs/helper/HelperPage';
import Devices from './Devices';
import Documents from '@/views/documents/Documents';
import SharedDocuments from './SharedDocuments';
import Tags from '../../../tags/pages/UsersTagPage';
import CommunicationOptions from '../../../communication_options/pages/PersonsCommunicationOptionsPage';
import Notifications from '@/modules/notifications/pages/UserNotificationsPage';
import InhabitantHistory from '@/modules/persons/components/InhabitantHistory';

export default {
  name: 'PersonTabs',

  components: {
    Employment,
    Relations,
    Helper,
    Devices,
    Documents,
    SharedDocuments,
    Tags,
    Notifications,
    InhabitantHistory,
    CommunicationOptions
  },

  props: {
    person: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    tab: null
  })
};
</script>
